<template>
  <ul
    v-if="localNavigation.length > 0"
    class="navigation-list"
    :class="{
      legacy: navType === 'legacy',
      storefront: navType === 'storefront'
    }"
    :style="listStyle"
  >
    <li
      v-for="secondaryNav in localNavigation"
      :key="secondaryNav.href"
      :class="navType === 'storefront' ? 'tertiary-nav' : 'secondary-nav'"
    >
      <span>
        <a v-if="!hideSeeAll" :href="secondaryNav.href">
          {{ secondaryNav.title || secondaryNav.name }}
        </a>
        <span v-else>
          {{ secondaryNav.title || secondaryNav.name }}
        </span>
      </span>
      <ul v-if="secondaryNav.subnav">
        <li
          v-for="tertiaryNav in secondaryNav.subnav"
          :key="tertiaryNav.href"
          class="tertiary-nav"
        >
          <a :href="tertiaryNav.href">
            {{ tertiaryNav.title || tertiaryNav.name }}
          </a>
        </li>
        <li v-if="navType !== 'legacy' && !hideSeeAll" class="tertiary-nav">
          <a :href="secondaryNav.href">
            {{ getAllCategoryText(secondaryNav) }}
          </a>
        </li>
      </ul>
    </li>
  </ul>
</template>

<script>
import { StringService } from "@nuskin/ns-util";

export default {
  name: "NsTopnavNavigation",
  props: {
    navigation: {
      type: [Array, String],
      default: function() {
        return [];
      }
    },
    navType: {
      type: String,
      default: ""
    },
    hideSeeAll: Boolean
  },
  data() {
    return {
      localTranslations: {
        allCategoryText: "See all %categoryName%"
      }
    };
  },
  computed: {
    localNavigation() {
      return Array.isArray(this.navigation)
        ? this.navigation
        : JSON.parse(this.navigation);
    },
    listStyle() {
      if (this.navType === "storefront") {
        return {
          maxWidth: this.localNavigation.length < 10 ? "750px" : "1000px",
          columns: this.localNavigation.length < 10 ? 3 : 4
        };
      }
      return {};
    }
  },
  mounted() {
    this.setCommonStrings();
  },
  methods: {
    getAllCategoryText(category) {
      const allCategoryText = this.localTranslations.allCategoryText;
      return allCategoryText.replace(
        "%categoryName%",
        category.title || category.name
      );
    },
    setCommonStrings() {
      const commonStrings = [
        { key: "allCategoryText", dflt: "See all %categoryName%" }
      ];
      StringService.getStrings(commonStrings).then(data => {
        this.localTranslations = { ...this.localTranslations, ...data };
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.navigation-list {
  display: grid;
  grid-template-columns: repeat(3, minmax(110px, 210px));
  grid-column-gap: 15px;
  width: 100%;
  margin: 30px 15px;
  list-style: none;
  justify-content: center;

  ul {
    list-style: none;
  }

  a {
    border-bottom: 1px solid transparent;
    color: rgb(39, 37, 37);
    line-height: normal;
    letter-spacing: 0px;
    text-decoration: none;
    transition: var(--global-transition);

    &:hover {
      border-bottom: 1px solid currentColor;
    }
  }

  &.legacy {
    display: flex;
    justify-content: center;

    .secondary-nav {
      width: calc(100% / 6);
      padding: 0 10px;
    }
  }

  &.storefront {
    display: block;
    margin: 30px auto;
  }
}

.secondary-nav {
  > span {
    display: list-item;
    padding: 6px 0;
    line-height: normal;

    > a {
      font-size: 15px;
      font-weight: 600;
    }
    > span {
      font-size: 15px;
      font-weight: 600;
    }
  }
}

.tertiary-nav,
.tertiary-nav > span {
  padding: 6px 0;
  line-height: normal;

  > a {
    font-size: 14px;
    font-weight: 300;
  }
}

@media screen and (min-width: 1024px) {
  .legacy .secondary-nav {
    width: calc(1024px / 6);
  }
}
</style>
